
import React, { useEffect, useState } from 'react';
import { Box, Grid,  Alert } from '@mui/material';
import { TrainingList } from './Index';
import dummyDataList from './TraininglistDummyData.json';
import { StencilList } from "react-placemoulder";
import TrainingFilter from './TrainingFilter';
import { my_training } from '../../../redux/actions/training.action';
import { useDispatch, useSelector } from 'react-redux';
import { CustomizedSnackbar } from '../../../shared/index';
import InfiniteScroll from "react-infinite-scroller";
import CommentModal from './CommentModal';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import MyExternalTraining from './MyExternalTraining';
import { useNavigate } from 'react-router';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function MyTraining() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [trainingList, setTrainingList] = useState(dummyDataList);
  const [loading, setLoading] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const [resultsPerPage, setResultsPerPage] = useState(6);
  const [title, setTitle] = useState("");
  const [statusId, setStatusId] = useState(0);
  const [scrolling, setScrolling] = useState(false);
  const [pagination, setPagination] = useState({});
  const [commentModal, setcommentModal] = useState(false);
  const [rejectComment, setRejectComment] = useState("");
  const [value, setValue] = React.useState(0);

  let trainingListReducer = useSelector(state => state.fetchMyTraining_Reducer.myTraining)

  useEffect(() => {
    var req = {
      "page": pageNo,
      "resultsPerPage": resultsPerPage,
      "title": title,
      "statusId": statusId
    }
    dispatch(my_training(req))
  }, [])

  useEffect(() => {
    if (trainingListReducer !== undefined) {
      if (trainingListReducer.pagination !== undefined) {
        setPagination(trainingListReducer.pagination)
        setPageNo(trainingListReducer.pagination.page)
      }
      if (trainingList && trainingList.length > 0 && trainingListReducer.pagination && trainingListReducer.pagination.page > 1) {
        var list = [...trainingList, ...trainingListReducer.trainings];
        setTrainingList(list)
        setScrolling(false);
        if (trainingListReducer.pagination !== undefined) {
          setPagination(trainingListReducer.pagination)
          setPageNo(trainingListReducer.pagination.page)
        }
      }
      else {
        setLoading(false)
        setTrainingList(trainingListReducer.trainings)
        if (trainingListReducer.pagination !== undefined) {
          setPagination(trainingListReducer.pagination)
          setPageNo(trainingListReducer.pagination.page)
        }
      }

    }
  }, [trainingListReducer])

  const handleTitleFilter = (value) => {
    setTitle(value)
  }

  const handleStatusFilter = (id) => {
    setStatusId(id)
  }

  const onSearch = (req) => {
    setLoading(true)
    dispatch(my_training(req))
  }

  const handlePagination = () => {
    if (pageNo + 1 <= pagination.totalPages) {
      setPageNo(pageNo + 1)
      var req = {
        "page": pageNo + 1,
        "resultsPerPage": resultsPerPage,
        "title": title,
        "statusId": statusId
      }
      dispatch(my_training(req))
      setScrolling(true)
    }
  }

  const handleComment = (val) => {
    if (commentModal) {
      setcommentModal(false)
    }
    else {
      setRejectComment(val);
      setcommentModal(true)
    }
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
    
  };

  
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: "15px", borderColor: "#113776" }}>
        <Tabs  className='training-tab' value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab className='one-tab' label="My Training" {...a11yProps(0)} />
          <Tab className='sec-tab' label="My External Training" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <div>
          <Grid container spacing={2}>
            <Grid item xs={12} sx={{marginTop: "15px"}}>
              <h1 className="main-heading">My Training</h1>
            </Grid>
            <Grid item xs={12} sx={{ paddingTop: "0px !important" }}>
              {pagination && pagination.totalRecords > 0 ?
                <p style={{ marginLeft: "5px", marginTop: "0px", marginBottom: "0" }}>You have got {trainingList.length} trainings </p> : ""}
            </Grid>
            <Grid item xs={3}>
              <TrainingFilter from="mytrainings"
                searchTitle={handleTitleFilter}
                searchStatus={handleStatusFilter}
                onFilter={onSearch}
              />
            </Grid>
            <Grid item xs={9}>
              <Box>
                {loading ?
                  <StencilList
                    length={5}
                    Component={TrainingList}
                    data={trainingList}
                  /> :
                  <>
                    <InfiniteScroll
                      // dataLength={trainingList.length}
                      initialLoad={false}
                      loadMore={scrolling === false ? handlePagination : ""}
                      hasMore={pageNo <= pagination.totalPages}
                      threshold={500}
                    >

                      {trainingList && trainingList.length > 0 && trainingList.map((trainingList) => {
                        return <TrainingList {...trainingList} key={trainingList.titleId} from="mytraining" handleCommentModal={handleComment} work="view" />
                      })}
                    </InfiniteScroll>
                    {trainingList && trainingList.length === 0 ? <Alert severity="error">No Trainings Found</Alert> : ""}
                  </>
                }
              </Box>
            </Grid>
          </Grid>
          <CustomizedSnackbar />
          <CommentModal open={commentModal} handleCommentModal={handleComment} comment={rejectComment} />
        </div>
      </TabPanel>
      <TabPanel value={value} index={1}>       
        <MyExternalTraining/>
      </TabPanel>
    </Box>
  );
}
export default MyTraining;
